import { useState } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import TextAreaField from "../../Shared/TextAreaField"
import AsyncSelectField from "../../Shared/AsyncSelect"
import FileField from "../../Shared/FileField"

const SendMessageForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [categoryOptions, setCategoryOptions] = useState([])

    const [formData, setFormData] = useState({
        category_id: "",
        message: "",
        file: null,
        char_counter: 0,
        sms_counter: 1,
    })
    const {category_id, message, file, char_counter, sms_counter} = formData

    const navigate = useNavigate()

    const loadOptions = async (url, query, setOptions) => {
        try {
            const response = await Server.get(`/options/${url}`, {
                params: { q: query },
            });
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };

    const onChange = (e) => {
        const { name, value, files } = e.target;
        setFormData((prev) => {
            const isMessage = name === "message";
            const isFile = name === "file";
            const newValue = isFile ? files[0] : value;
          
            const newMessage = isMessage ? newValue : prev.message;
            const charDiff = isMessage ? newMessage.length - prev.message.length : 0;
          
            return {
              ...prev,
              [name]: newValue,
              char_counter: isMessage ? Math.max(0, prev.char_counter + charDiff) : prev.char_counter,
              sms_counter: isMessage ? Math.ceil(newMessage.length / 160) : prev.sms_counter,
            };
        });
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const payload = {category_id, message, file}
        sendMessage(payload)
    }
    
    const sendMessage = async (payload) => {
        setIsLoading(true);

        const dataToSend = new FormData();
        dataToSend.append("category_id", payload.category_id);
        dataToSend.append("message", payload.message);
        dataToSend.append("file", payload.file);

        try {
            const response = await Server.post(`/messages/send/custom`, dataToSend, {headers: {'Content-Type': 'multipart/form-data'}})
            toast.success(response?.data?.detail)
            navigate(`/`)
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login');
            }else if (error.response.status === 422){
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response?.data?.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Send Custom Message Form</h3>
            </div>
            <div className="card-body">
            <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-6">
                            <AsyncSelectField
                                name="category_id"
                                label="Category"
                                value={category_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('message-categories', query, setCategoryOptions)}
                                options={categoryOptions}
                                placeholder="Start typing to search..."
                                error={errors.category_id}
                            />
                        </div>
                        <div className="col-md-6">
                            <FileField
                            name="file"
                            type="file"
                            label="File"
                            value={file}
                            onChange={onChange}
                            error={errors.file}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <TextAreaField
                                placeholder="Message"
                                name="message"
                                type="text"
                                label="Message"
                                required="required"
                                value={message}
                                onChange={onChange}
                                error={errors.message}
                            />
                            <span className="text-orange h3" style={{float: 'right', marginRight: '20px'}}>{`Characters: ${char_counter}, SMS: ${sms_counter}`}</span>
                        </div>
                        
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Send Message" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default SendMessageForm
